import React from 'react';
import { useMutation, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';
import servicePeople from 'services/people';

/** @typedef {number} UseResendOptInConfirmationEmailMutationVariables */

/** @typedef {import('services/people').ResendOptInConfirmationEmailResponse} ResendOptInConfirmationEmailResponse */

/** @typedef {Omit<UseMutationOptions<ResendOptInConfirmationEmailResponse, Error, UseResendOptInConfirmationEmailMutationVariables, unknown>, 'mutationKey' | 'mutationFn'>} UseResendOptInConfirmationEmailMutationOptions */

/**
 * Resend the opt-in confirmation email mutation.
 * @param {UseResendOptInConfirmationEmailMutationOptions} [options={}]
 */
export const useResendOptInConfirmationEmailMutation = (options = {}) => {
    return useMutation({
        ...options,
        mutationKey: ['resend-opt-in-confirmation-email'],
        /** @param {UseResendOptInConfirmationEmailMutationVariables} personId */
        mutationFn: personId => servicePeople.resendOptInConfirmationEmail(personId)
    });
};

/**
 * @param {React.ComponentType} Component
 * @param {UseResendOptInConfirmationEmailMutationOptions} [options]
 * @returns {(props: any) => React.ReactElement}
 */
export const withResendOptInConfirmationEmailMutation = (Component, options) => props => {
    const resendOptInConfirmationEmailMutation = useResendOptInConfirmationEmailMutation(options);
    return <Component {...props} resendOptInConfirmationEmailMutation={resendOptInConfirmationEmailMutation} />;
};
